export const disableFreeTextNewOptions = (newOption: string, allowFreeTextOptionCallback: () => void, cancelFreeTextOptionCallback: () => void) => {
    if (newOption) {
        cancelFreeTextOptionCallback();
    }
};
